/**
 * Best-effort client IP capture for marketing-consent audit trails.
 *
 * Used at signup (when the user ticks the marketing-consent box) and on the
 * Profile page (when an existing user taps the opt-in nudge). Stored in
 * `profiles.marketing_consent_ip` as corroborating evidence per GDPR Art. 7(1)
 * "demonstrate consent".
 *
 * Failure modes (offline, blocked, ipify down) resolve to `null`. Never throws.
 */
const IPIFY_URL = "https://api.ipify.org?format=json";

export async function fetchClientIp(): Promise<string | null> {
  try {
    const res = await fetch(IPIFY_URL);
    if (!res.ok) return null;
    const json = (await res.json()) as { ip?: unknown };
    return typeof json.ip === "string" ? json.ip : null;
  } catch {
    return null;
  }
}
